import React from 'react'
import Monitors from '../Monitors/Monitors';
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as Actions from "../redux/action";
import MonitorImg from "../../../icons/MonitorImg.svg";

const FacilitiesDetails = (props) => {
  return (
    <div>
          <h1 className="text-Heading"> 
          <img src={MonitorImg} alt="MonitorImg"></img>        
          <span className="facility-name">{props.facilityName}</span>
          <span> / Monitors</span>
        </h1>
       
        <div className= "facility-details-page">
        <Monitors ></Monitors>
        </div> 
    </div>
  )
}

// export default FacilitiesDetails
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      changeFacilityMenu: Actions.changeFacility,
      changeFacilityName: Actions.FacilityName
    },
    dispatch
  );
}

function mapStateToProps(state) {
  return {
    facilityName: state.facilityName
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(FacilitiesDetails)
);
